import React, { useMemo, useRef } from 'react';
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import AccordionComponent from '../../../../common/Accordion';
import { useEffect, useState } from 'react';
import DataTable from '../../../../common/DataTable';
import { downloadQMEFormsZip, downloadQMEFormsZipForRecordList } from '../../../../services/AppointmentsAPI';
import {
  FILE_HEADERS,
  RECORD_LIST_BY_SENDER_HEADERS,
  RECORD_LIST_BY_SENDER_HEADERS_VIEW,
  RECORD_LIST_HEADERS,
  RECORD_LIST_HEADERS_VIEW,
  RECORD_LIST_ATTACHMENT_HEADERS,
  RECORD_LIST_ATTACHMENT_BY_SENDER_HEADERS,
  VERSION_HEADER,
} from '../actions/Constant';
import {
  downloadZipFileForDocumentCategory,
  downloadZipFileForHeader,
  downloadZipFileForPopUpDetails,
  getDownloadFileForPopUpDetails,
  getRecordListCountDetails,
  getRecordListData,
  getRecordListPopUpDetails,
  getRecordAttachmentsByCase,
  getRecordAttachmentsSummaryByCase,
} from '../../../../services/UploadRecordsApi';
import Loader from '../../../../common/Loader';
import DataTableForList from './ExpandableTable';
import UploadStatusFloatingIcon from '../../../../common/UploadStatusFloatingIcon';
import PdfViewerDrawer from '../../../../common/PDFFileViewerDrawer';
import SearchInput from '../../../../common/InlineSearch';
import debounce from 'lodash.debounce';
import DocumentCategoryList from './DocumentCategoryList';
import DocumentCards from './DocumentCards';
import AttachmentExpandableTable from './AttachmentExpandableTable';
import RORDataTable from '../../../ToDos/RecordReviewer/components/RecordReviewerUploadRecord/RORDataTable';
import { REVIEW_RECORD_HEADERS } from '../../../ToDos/RecordReviewer/actions/constants';
import {
  GetReviewerRecordList,
  GetReviewerRecordSummaryList,
} from '../../../../services/RecordReviewerAPI';

interface RecordListProps {
  caseInfoId: number;
  action: string;
  loggedInUserid: number | null;
  recordActiveTab: string;
  onCancel: (action: string) => void;
  onRowSelect: (selectedRowData: any) => void;
  isEditorFile?: boolean;
  toDosMainTab?: string;
  selectedRORData?: any;
  isRORPopUpShow?: boolean;
}

export interface UploadStatus {
  fileName: string;
  progress: number;
  isUploading: boolean;
}

const RecordListNew: React.FC<RecordListProps> = ({
  caseInfoId,
  onRowSelect,
  recordActiveTab,
  onCancel,
  isEditorFile = false,
  toDosMainTab = '',
  selectedRORData = {},
  isRORPopUpShow = false,
}) => {
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [activeKeysROR, setActiveKeysROR] = useState<string[]>([]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const [showModalForROR, setShowModalForROR] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState<string>('');
  const [selectedClientName, setSelectedClientName] = useState<string>('');
  const [totalPageCount, setTotalPageCount] = useState<number | null>(null);
  const [countResult, setCountResult] = useState<any[]>([]);
  const [listResult, setListResult] = useState<any[]>([]);
  const [popUpListResult, setPopUpListResult] = useState<any[]>([]);
  const [versionListResult, setVersionListResult] = useState<any[]>([]);
  const [recordLists, setRecordLists] = useState<{ [key: string]: any[] }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingFile, setLoadingFile] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessagePopUp, setShowMessagePopUp] = useState<boolean>(false);
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});
  const [sortBySender, setSortBySender] = useState(false);
  const [isViewBy, setIsViewBy] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState<string | null>(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [reviewRecordSummaryResult, setReviewRecordSummaryResult] = useState<
    any[]
  >([]);
  const [recordRORLists, setRecordRORLists] = useState<{
    [key: string]: any[];
  }>();
  const [selectedRORPopUp, setSelectedRORPopUp] = useState<any>({});
  const [isAttachFileView, setIsAttachFileView] = useState<boolean>(false);
  const [attachmentsResult, setAttachmentsResult] = useState<any[]>([]);
  const [attachmentsSummaryResult, setAttachmentsSummaryResult] = useState<any[]>([]);
  const searchInputRef = useRef<any>(null);
  const sortBySenderRef = useRef(sortBySender);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const latestRequestRef = useRef(0);
  const isAttachFileViewRef = useRef(isAttachFileView);
  const prevSearchRef = useRef('');

  const subjectQmeScheduleIdROR =
    toDosMainTab === "TODO_Editor"
      ? selectedRORData?.subjectQmeScheduleID ?? ""
      : ["Record_Review", "TODO_Doctor"].includes(toDosMainTab)
        ? selectedRORData?.subjectQmeScheduleId ?? ""
        : "";

  useEffect(() => {
    sortBySenderRef.current = sortBySender;
    searchInputRef.current?.clear();
  }, [sortBySender]);

  useEffect(() => {
    isAttachFileViewRef.current = isAttachFileView;
  }, [isAttachFileView]);

  const debouncedSearch = useRef(
    debounce((query: string) => {
      handleServerSideSearch(query);
    }, 500),
  ).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const fetchListCountData = async (searchQuery: string = '') => {
    const requestId = ++latestRequestRef.current;
    try {
      setLoading(true);
      const groupType = sortBySenderRef.current == false ? 1 : 0;
      const listCountData = await getRecordListCountDetails(
        caseInfoId,
        groupType,
        searchQuery,
        subjectQmeScheduleIdROR,
      );

      if (requestId !== latestRequestRef.current) return;
      const result = listCountData?.result || [];
      setCountResult(result);

      if (result?.length > 0) {
        const firstCategory = result[0].datacategory;
        const firstKeyId = Number(result[0].keyId);

        setActiveKeys(['0']);
        await fetchRecordListDataNew(firstCategory, firstKeyId, searchQuery);
      }
    } catch (error) {
      if (requestId === latestRequestRef.current) {
        console.error('Error fetching count data:', error);
      }
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  const fetchRecordAttachments = async (query: string = "", subjectQmeScheduleID: any = null) => {
    const requestId = ++latestRequestRef.current;
    try {
      setLoading(true);
      const groupType = sortBySenderRef.current == false ? 1 : 0;
      const recordData = {
        caseInfoId: caseInfoId,
        groupType: groupType,
        searchString: query,
        subjectQmeScheduleID: subjectQmeScheduleID,
      }
      const data = await getRecordAttachmentsByCase(recordData);
      if (requestId !== latestRequestRef.current) return;
      setAttachmentsResult(data || []);
    } catch (error) {
      if (requestId === latestRequestRef.current) {
        console.error("Error fetching record attachments:", error);
      }
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  const fetchRecordAttachmentsSummary = async (query: string = "") => {
    const requestId = ++latestRequestRef.current;
    try {
      setLoading(true);
      const groupType = sortBySenderRef.current == false ? 1 : 0;
      const recordData = {
        caseInfoId: caseInfoId,
        groupType: groupType,
        searchString: query,
        subjectQmeScheduleID: null,
      }
      const data = await getRecordAttachmentsSummaryByCase(recordData);
      if (requestId !== latestRequestRef.current) return;
      const result = data || [];
      setAttachmentsSummaryResult(result);
      if (result.length > 0) {
        fetchRecordAttachments(query, result[0].subjectQMEScheduleID);
      }
    } catch (error) {
      if (requestId === latestRequestRef.current) {
        console.error("Error fetching record attachments:", error);
      }
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (caseInfoId) {
      fetchRecordAttachmentsSummary();
    }
  }, [caseInfoId]);

  useEffect(() => {
    if (recordActiveTab !== 'Record List') {
      setSortBySender(false);
      setIsExpanded(false);
      return;
    }
    if (isExpanded && countResult?.length > 0) {
      const newKeys = countResult?.map((_, index) => index.toString());
      setActiveKeys(newKeys);
    } else {
      setActiveKeys([]);
    }
    fetchListCountData();
  }, [recordActiveTab, sortBySender]);

  useEffect(() => {
    if (isAttachFileView) {
      fetchRecordAttachmentsSummary(searchQuery);
    } else {
      fetchListCountData(searchQuery);
    }
  }, [isAttachFileView, sortBySender]);

  useEffect(() => {
    if (isExpanded && countResult?.length > 0) {
      const newKeys = countResult?.map((_, index) => index.toString());
      setActiveKeys(newKeys);

      countResult.forEach(({ datacategory, keyId }) => {
        fetchRecordListDataNew(datacategory, keyId, searchQuery);
      });
    }
  }, [countResult, isExpanded]);

  const fetchRecordListDataNew = async (
    datacategory: string,
    KeyId: number,
    searchQuery: string = '',
  ) => {
    try {
      const listData = await getRecordListData(
        caseInfoId,
        datacategory,
        KeyId,
        searchQuery,
        subjectQmeScheduleIdROR,
      );

      setRecordLists((prev) => ({
        ...prev,
        [datacategory]: listData?.result || [],
      }));
    } catch (error) {
      console.error('Error fetching record list data:', error);
    }
  };

  const fetchPopUpListDetails = async (caseRecordHeaderId: number, tagType: string) => {
    try {
      setLoading(true);
      const popUpListData = await getRecordListPopUpDetails(caseRecordHeaderId, tagType);
      setPopUpListResult(popUpListData?.result || []);
      setTotalPageCount(
        (popUpListData?.result?.[0] as any)?.totalPageCount || null,
      );
    } catch (error) {
      console.error('Error fetching record list data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = 'File.zip',
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error('Download error:', error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const toggleAll = async () => {
    if (isExpanded) {
      setActiveKeys([]);
      setIsExpanded(false);
    } else {
      const newKeys = countResult.map((_, index) => index.toString());
      setActiveKeys(newKeys);
      setIsExpanded(true);
      await Promise.all(
        countResult.map(({ datacategory, keyId }) =>
          fetchRecordListDataNew(datacategory, keyId, searchQuery),
        ),
      );
    }
  };

  const handleAccordionToggle = async (
    key: string | null,
    datacategory: string,
    KeyId: number,
  ) => {
    if (!key) return;

    const newActiveKeys = activeKeys.includes(key)
      ? []
      : [key];

    setActiveKeys(newActiveKeys);

    if (newActiveKeys?.length === countResult?.length) {
      setIsExpanded(true);
    } else if (isExpanded) {
      setIsExpanded(false);
    }

    await fetchRecordListDataNew(datacategory, KeyId, searchQuery);
  };

  const fetchRORListData = async (row: any, query: string = searchQuery) => {
    try {
      const reviewRecordSummaryData = await GetReviewerRecordSummaryList(
        row?.caseInfoId,
        selectedRORData?.subjectQmeScheduleId,
        query,
      );
      const resultList = reviewRecordSummaryData?.result ?? [];
      setReviewRecordSummaryResult(resultList);

      if (resultList?.length > 0) {
        const firstKey = '0';
        const firstCategory = resultList[0].dataCategory;
        const firstCategoryKeyId = Number(resultList[0].keyID);
        setActiveKeysROR([firstKey]);
        const listData = await GetReviewerRecordList(
          row?.caseInfoId,
          firstCategoryKeyId,
          selectedRORData?.subjectQmeScheduleId,
          query,
        );
        setRecordRORLists((prev) => ({
          ...prev,
          [firstCategory]: listData?.result || [],
        }));
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchRORListDataOnToggle = async (
    caseInfoId: number,
    KeyId: number,
    dataCategory: string,
    query: string = searchQuery,
  ) => {
    try {
      const listData = await GetReviewerRecordList(caseInfoId, KeyId, selectedRORData?.subjectQmeScheduleId, query);
      setRecordRORLists((prev) => ({
        ...prev,
        [dataCategory]: listData?.result || [],
      }));
    } catch (error) {
      console.error('Error fetching record list data:', error);
    }
  };

  const handleAccordionToggleROR = async (
    key: string | null,
    dataCategory: string,
    KeyID: number,
  ) => {
    if (!key) return;
    setActiveKeysROR((prevActiveKeys = []) => {
      if (prevActiveKeys.includes(key)) {
        return prevActiveKeys.filter((k) => k !== key);
      }

      return [...prevActiveKeys, key];
    });
    await fetchRORListDataOnToggle(
      selectedRORPopUp?.caseInfoId,
      KeyID,
      dataCategory,
      searchQuery,
    );
  };

  const handleRowAction = (row: any) => {
    setActiveKeys([]);
    onRowSelect(row);
  };

  const handleRORPopUpAction = async (row: any) => {
    setShowModalForROR(true);
    setSelectedRORPopUp(row);
    fetchRORListData(row);
  };

  const handleToggleSort = () => {
    setSortBySender((prev) => !prev);
  };

  const renderAccordion = () => (
    <AccordionComponent
      items={countResult.map(
        (
          {
            datacategory,
            totalRecords,
            lastUploadedBy,
            lastUploadedOn,
            keyId,
            categorywiseTotalPageCount,
          },
          index
        ) => {
          const has110Form =
            recordLists[datacategory]?.some(
              (item) =>
                item.documentTypeName ===
                "110 Form (QME Appointment Notification)",
            ) || false;

          const hasTranscription =
            recordLists[datacategory]?.some(
              (item) =>
                item.documentTypeName === "Transcription" ||
                item.documentTypeName === "Draft Transcription",
            ) || false;

          const baseHeaders = has110Form
            ? sortBySender
              ? RECORD_LIST_BY_SENDER_HEADERS_VIEW
              : RECORD_LIST_HEADERS_VIEW
            : sortBySender
              ? RECORD_LIST_BY_SENDER_HEADERS
              : RECORD_LIST_HEADERS;

          const headers = hasTranscription
            ? baseHeaders
            : baseHeaders?.filter((header) => header.key !== "totalLineCount" && header.key !== "totalPageCountTrans");

          return {
            title: (
              <div className="d-flex align-items-center w-100">
                <div className="me-auto d-flex align-items-center">
                  {datacategory}{" "}
                  <Badge bg="primary" className="ms-2 primary-badge">
                    {totalRecords}
                  </Badge>
                  {categorywiseTotalPageCount != null && (
                    <>
                      <span className="ms-3 material-icons theme-color">
                        auto_stories
                      </span>
                      <span className="ms-1 theme-color mx-1 fw-light">
                        Pages -{" "}
                      </span>
                      <span className="text-muted">
                        {categorywiseTotalPageCount}
                      </span>
                    </>
                  )}
                </div>

                <div className="fw-normal accord-righttext me-3">
                  <div className="d-flex align-items-center justify-content-end">

                    <span className='me-2'>
                      Last Uploaded On:{" "}
                      {new Date(lastUploadedOn).toLocaleDateString("en-US")}{" "}
                      <span className="theme-color"> | {lastUploadedBy}</span>
                    </span>
                    <Button
                      variant="primary"
                      size="sm"
                      className="d-flex align-items-center me-1 px-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleHeaderFileDownloadAction(datacategory);
                      }}
                    >
                      <span className="material-icons">download</span>
                    </Button>

                  </div>
                </div>
              </div>
            ),

            content: (
              <div className={has110Form ? "records-page-count110" : "records-page-count"}>
                <DataTable
                  headers={headers}
                  rows={recordLists[datacategory] || []}
                  onAction={handleRowAction}
                  onFileAction={handleFileAction}
                  onDownloadAction={handle110DownloadAction}
                  toDosMainTab={toDosMainTab}
                  onRORPopUpAction={handleRORPopUpAction}
                  sortBySender={sortBySender}
                  selectedRORData={selectedRORData || {}}
                  isRORPopUpShow={isRORPopUpShow}
                />
              </div>
            ),

            eventKey: index.toString(),
          };
        }
      )}
      activeKey={activeKeys}
      onSelect={(key) => {
        const index = parseInt(key || "0");
        const { datacategory, keyId } = countResult[index];
        handleAccordionToggle(key, datacategory, keyId);
      }}
    />
  );

  const handleFileAction = (row: any) => {
    setPopUpListResult([]);
    setTotalPageCount(null);
    setSelectedFileName('');
    setSelectedClientName('');
    fetchPopUpListDetails(row.caseRecordHeaderId, row.tagType);
    setShowModalNew(true);
    setSelectedFileName(row?.documentTypeName);
    setSelectedClientName(row?.senderKeyName);
  };

  const handleDownloadAction = (row: any) => {
    handleDownloadProgress(
      row?.caseRecordDetailsId,
      () =>
        getDownloadFileForPopUpDetails(row?.caseRecordDetailsId, row?.fileName),
      row?.fileName,
    );
  };

  const handle110DownloadAction = (row: any) => {
    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadQMEFormsZipForRecordList([row.caseRecordHeaderId]),
    );
  };

  const viewPDF = (row: any) => {
    const fileUrl = row.download;
    const isPdf = fileUrl?.toLowerCase().endsWith('.pdf');
    const isImage = /\.(png|jpe?g|gif|tiff?|heif|heic|webp)$/i.test(
      fileUrl || '',
    );

    if (isPdf || isImage) {
      setSelectedPdfUrl(fileUrl);
      setIsViewerOpen(true);
    } else {
      alert('Unsupported file format');
    }
  };

  const handlePopUpDetailsFileDownloadAction = () => {
    const ids = popUpListResult
      .map((item) => item.caseRecordDetailsId)
      .join(',');
    handleDownloadProgress(`popup-${Date.now()}`, () =>
      downloadZipFileForPopUpDetails(ids),
    );
  };

  const handleHeaderFileDownloadAction = (datacategory: string) => {
    const groupType = sortBySender == false ? 1 : 0;
    const ids = (recordLists[datacategory] || [])
      .map((item) => item.caseRecordHeaderId)
      .join(',');

    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(ids, groupType, searchQuery),
    );
  };

  const handleHeaderFileDownloadActionROR = async (datacategory: string, keyID: any) => {
    const listDataNew = await GetReviewerRecordList(caseInfoId, keyID, selectedRORData?.subjectQmeScheduleId, searchQuery);
    const newIDs = listDataNew?.result?.map((item) => item.caseRecordHeaderID).join(',') || '';
    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(newIDs, 1, ''),
    );
  };

  const handleDownloadSingleFileROR = (row: any) => {
    handleDownloadProgress(
      row?.caseRecordDetailsID,
      () =>
        getDownloadFileForPopUpDetails(row?.caseRecordDetailsID, row?.fileName),
      row?.fileName,
    );
  };

  const handleDocumentCategoryFileDownloadAction = () => {
    const groupType = sortBySender == false ? 1 : 0;
    handleDownloadProgress(caseInfoId.toString(), () =>
      downloadZipFileForDocumentCategory(caseInfoId, groupType, searchQuery),
    );
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
    setSelectedFileName('');
    setSelectedClientName('');
    setTotalPageCount(null);
  };

  const handleCloseModalROR = () => {
    setShowModalForROR(false);
  };

  const handleCloseEditor = () => {
    setShowModalNew(false);
    setSelectedFileName('');
    setSelectedClientName('');
    setTotalPageCount(null);
    onCancel('Cancel');
  };

  const formatClientName = (name: any) => {
    // Get the name before the first `[` or comma
    const namePart = name.split(/[\[,]/)[0].trim();
    // Extract the first tag inside square brackets (e.g., Client, Defence)
    const tagMatch = name.match(/\[(.*?)\]/);
    const tag = tagMatch ? tagMatch[1].trim() : null;
    // If there's a tag, append it with "Attorney"
    const formattedSuffix = tag ? ` (${tag})` : '';

    return namePart + formattedSuffix;
  };

  const handleServerSideSearch = async (query: string) => {
    const trimmedQuery = query?.trim();
    setSearchQuery(trimmedQuery);
    if (isAttachFileViewRef.current) {
      await fetchRecordAttachmentsSummary(trimmedQuery);
    } else if (showModalForROR) {
      await fetchRORListData(selectedRORPopUp, trimmedQuery);
    } else {
      await fetchListCountData(trimmedQuery);
    }
  };

  const handleSearchQueryChange = (query: string) => {
    const trimmedQuery = query?.trim() || "";
    if (prevSearchRef.current === trimmedQuery) return;
    prevSearchRef.current = trimmedQuery;
    setSearchQuery(trimmedQuery);
    if (trimmedQuery === "") {
      debouncedSearch.cancel();
      if (isAttachFileView) {
        fetchRecordAttachmentsSummary();
      } else if (showModalForROR) {
        fetchRORListData(selectedRORPopUp);
      } else {
        fetchListCountData();
      }
    } else {
      debouncedSearch(trimmedQuery);
    }
  };

  const handleResetSearch = () => {
    if (!searchQuery?.trim()) return;
    searchInputRef.current?.clear();
    setSearchQuery('');
    if (isAttachFileView) {
      fetchRecordAttachmentsSummary();
    } else if (showModalForROR) {
      fetchRORListData(selectedRORPopUp);
    } else {
      fetchListCountData();
    }
  };

  const getActiveCategoryDetails = () => {
    if (activeKeys?.length === 0 || countResult?.length === 0) return null;

    const activeCategory = activeKeys[0];
    const categoryData = countResult.find(
      (_, index) => index.toString() === activeCategory,
    );

    if (!categoryData) return null;

    return {
      datacategory: categoryData.datacategory,
      totalRecords: categoryData.totalRecords,
      lastUploadedBy: categoryData.lastUploadedBy,
      lastUploadedOn: categoryData.lastUploadedOn,
      keyId: categoryData.keyId,
      categorywiseTotalPageCount: categoryData.categorywiseTotalPageCount,
    };
  };

  const activeCategoryDetails = getActiveCategoryDetails();

  const handleCardAction = (row: any, actionType: 'row' | 'file' | 'download') => {
    if (actionType === 'row') {
      handleRowAction(row);
    } else if (actionType === 'file') {
      handleFileAction(row);
    } else if (actionType === 'download') {
      handle110DownloadAction(row);
    }
  };

  const handleCategorySelect = (category: any) => {
    const index = countResult.findIndex(
      (cat) => cat.datacategory === category.datacategory,
    );
    if (index !== -1) {
      const key = index.toString();
      setActiveKeys([key]);
      fetchRecordListDataNew(
        category.datacategory,
        category.keyId,
        searchQuery,
      );
    }
  };

  const renderAccordionROR = () => (
    <AccordionComponent
      items={reviewRecordSummaryResult.map(
        (
          {
            dataCategory,
            totalRecords,
            lastUploadedBy,
            lastUploadedOn,
            keyID,
            categoryWiseTotalPageCount,
          },
          index,
        ) => ({
          title: (
            <div className='d-flex align-items-center w-100'>
              <div className='me-auto d-flex align-items-center w-60'>
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip>{dataCategory}</Tooltip>}
                >
                  <span className='text-truncate w-50'>{dataCategory} </span>
                </OverlayTrigger>

                <Badge bg='primary' className='ms-2 primary-badge '>
                  {totalRecords}
                </Badge>
                {categoryWiseTotalPageCount != null && (
                  <>
                    <span className='ms-3 material-icons theme-color'>
                      auto_stories
                    </span>
                    <span
                      className='ms-1 theme-color mx-1 fw-light'
                      style={{ width: '55px', textAlign: 'left' }}
                    >
                      Pages -{' '}
                    </span>
                    <span className='text-muted'>
                      {categoryWiseTotalPageCount}
                    </span>
                  </>
                )}
              </div>
              <div className='fw-normal accord-righttext me-3'>
                <div className='d-flex align-items-center justify-content-end'>

                  <span className="me-2" style={{ width: '100%', display: 'inline-flex' }}>

                    <span style={{ width: '81%', marginTop: '5px', display: 'inline-block', textAlign: 'right', paddingRight: '10px' }}>Last Uploaded On:{' '}
                      {new Date(lastUploadedOn).toLocaleDateString('en-US')}{' '} </span>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>{lastUploadedBy}</Tooltip>}
                    >
                      <span className='theme-color text-truncate' style={{ width: '50%', float: 'right', marginTop: '5px' }}> | {lastUploadedBy} </span>
                    </OverlayTrigger>
                  </span>
                  <Button
                    variant='primary'
                    size='sm'
                    className='d-flex align-items-center me-2 px-1'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleHeaderFileDownloadActionROR(dataCategory, keyID);
                    }}
                  >
                    <span className='material-icons'>download</span>
                  </Button>
                </div>
              </div>
            </div>
          ),
          content: (
            <>
              <div className='records-page-count recordtotal'>
                {recordRORLists &&
                  recordRORLists[dataCategory] &&
                  recordRORLists[dataCategory]?.length > 0 ? (
                  <RORDataTable
                    headers={REVIEW_RECORD_HEADERS}
                    rows={recordRORLists[dataCategory] || []}
                    onDownloadAction={handleDownloadSingleFileROR}
                    disabled={true}
                  />
                ) : (
                  <div>
                    <Row>
                      <span className='no_rec_data'>No Record Found</span>
                    </Row>
                  </div>
                )}
              </div>
            </>
          ),
          eventKey: index.toString(),
        }),
      )}
      activeKey={activeKeysROR}
      onSelect={(key) => {
        const index = parseInt(key || '0');
        const { dataCategory, keyID } = reviewRecordSummaryResult[index];
        handleAccordionToggleROR(key, dataCategory, keyID);
      }}
      isROR={true}
    />
  );

  const totalRecords = useMemo(() => {
    return countResult.reduce((total, item) => total + item.totalRecords, 0);
  }, [countResult]);

  const totalPages = useMemo(() => {
    return countResult.reduce(
      (total, item) => total + item.categorywiseTotalPageCount,
      0,
    );
  }, [countResult]);

  return (
    <>
      <Loader isLoading={loading} />
      {showMessage && (
        <div className='alert alert-info text-center position-fixed'>
          Download is in progress...
        </div>
      )}

      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />

      <Container fluid className='pb-5'>
        <Row className='mt-3 align-items-center px-2 py-1'>
          <Col className='d-flex  align-items-center border-bottom pb-2 px-0 mb-2'>
            <h3 className='me-auto mb-0 d-flex  align-items-center'>
              List Of All Records
              <Badge bg='danger' className='ms-2 danger-badge'>
                {totalRecords}
              </Badge>
              <span className='ms-3 material-icons theme-color'>
                auto_stories
              </span>
              <span className='ms-1 theme-color'>Pages - </span>{' '}
              <span className='text-muted mx-1'>
                {totalPages}
              </span>
            </h3>
            <div className='d-flex search_closer'>
              <div style={{ width: '80%' }} className='gridsearch'>
                <SearchInput
                  ref={searchInputRef}
                  data={[]}
                  searchKeys={[]}
                  onSearchResult={() => { }}
                  placeholder='Search'
                  onSearchQueryChange={handleSearchQueryChange}
                />
              </div>
              <button
                onClick={handleResetSearch}
                className='reset_btn'
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  marginTop: '4px',
                }}
              >
                <span className='material-icons reset_ic0'>restart_alt</span>
              </button>
            </div>
            <div className='d-flex align-items-center me-3 toggle-btn toggleVarient'>
              <span className='me-3 fw-semibold'>View By</span>
              <Button
                variant={isViewBy && !isAttachFileView ? 'primary' : 'outline-secondary'}
                className={`d-flex align-items-center radiusNone ${isViewBy && !isAttachFileView ? 'active' : ''
                  }`}
                onClick={() => {
                  if (isAttachFileView) {
                    handleResetSearch();
                  }
                  setIsViewBy(true);
                  setIsAttachFileView(false);
                }}
              >
                <span className='material-symbols-outlined'>grid_view</span>
              </Button>
              <Button
                variant={!isViewBy && !isAttachFileView ? 'primary' : 'outline-secondary'}
                className={`d-flex align-items-center radiusNoneRt ${!isViewBy && !isAttachFileView ? 'active' : ''
                  }`}
                onClick={() => {
                  if (isAttachFileView) {
                    handleResetSearch();
                  }
                  setIsViewBy(false);
                  setIsAttachFileView(false);
                }}
              >
                <span className='material-symbols-outlined'>view_headline</span>
              </Button>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-view-attachments">View Attachments</Tooltip>}
              >
                <Button
                  variant={isAttachFileView ? 'primary' : 'outline-secondary'}
                  className={`d-flex align-items-center ms-1 ${isAttachFileView ? 'active' : ''}`}
                  onClick={() => {
                    setIsAttachFileView(true);
                    setIsViewBy(false);
                    handleResetSearch();
                  }}
                >
                  <span className='material-symbols-outlined'>file_copy</span>
                </Button>
              </OverlayTrigger>
            </div>
            <div className='d-flex align-items-center me-3 toggle-btn'>
              <span className='me-3 fw-semibold'>Sort By</span>
              <span className='me-2'>Category</span>
              <Form.Check
                type='switch'
                id='sort-switch'
                checked={sortBySender}
                onChange={handleToggleSort}
              />
              <span className='ms-1'>Sender</span>
            </div>

            <Button
              variant='primary'
              className='border-top d-flex justify-content-end px-1'
              style={{ marginRight: '44px' }}
              onClick={handleDocumentCategoryFileDownloadAction}
            >
              <span className='material-icons'>download</span>
            </Button>
            {!isViewBy && (
              <button
                type='button'
                className='btn d-flex align-items-center btn-text-border float-end position-absolute'
                onClick={toggleAll}
                style={{ right: '62px', padding: '3px 5px' }}
              >
                <span className='material-symbols-outlined'>
                  {isExpanded ? 'collapse_all' : 'expand_all'}
                </span>
              </button>
            )}
          </Col>
        </Row>

        {isAttachFileView ? (
          <AttachmentExpandableTable
            summaryRows={attachmentsSummaryResult}
            attachmentsResult={attachmentsResult}
            onFetchAttachments={fetchRecordAttachments}
            onViewPdf={viewPDF}
            onDownloadAction={handleDownloadAction}
            sortBySender={sortBySender}
            RECORD_LIST_ATTACHMENT_BY_SENDER_HEADERS={RECORD_LIST_ATTACHMENT_BY_SENDER_HEADERS}
            RECORD_LIST_ATTACHMENT_HEADERS={RECORD_LIST_ATTACHMENT_HEADERS}
            searchQuery={searchQuery}
          />
        ) : countResult?.length === 0 ? (
          <div className='text-center no_rec_data'>
            <span className='newThingsNod '>No Record Found</span>
          </div>
        ) : !isViewBy ? (
          <>{renderAccordion()}</>
        ) : (
          <>
            <Row>
              <Col md={9}>
                <div className='me-auto d-flex align-items-center'>
                  <div className='col-md-12 mb-3'>
                    <div className='row pt-2'>
                      <div className='col-md-6'>
                        {activeCategoryDetails ? (
                          <>
                            <span className='fw-semibold title_tx'>
                              {activeCategoryDetails.datacategory}
                            </span>
                            {activeCategoryDetails.categorywiseTotalPageCount !=
                              null && (
                                <>
                                  <span className='ms-3 material-icons theme-color'>
                                    auto_stories
                                  </span>
                                  <span className='ms-1 theme-color mx-1 fw-light'>
                                    Pages -{' '}
                                  </span>
                                  <span className='text-muted'>
                                    {
                                      activeCategoryDetails.categorywiseTotalPageCount
                                    }
                                  </span>
                                </>
                              )}
                          </>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className='col-md-6'>
                        {activeCategoryDetails && (
                          <>
                            <span className='d-flex' style={{ float: 'right' }}>
                              <Button
                                variant='primary'
                                className='border-top d-flex justify-content-end px-1'
                                onClick={(e) => {
                                  handleHeaderFileDownloadAction(
                                    activeCategoryDetails?.datacategory,
                                  );
                                }}
                              >
                                <span className='material-icons'>download</span>
                              </Button>
                              <span
                                style={{ marginLeft: '10px', marginTop: '5px' }}
                              >
                                Last Uploaded On:{' '}
                                {new Date(
                                  activeCategoryDetails.lastUploadedOn,
                                ).toLocaleDateString('en-US')}{' '}
                                <span className='theme-color'>
                                  {' '}
                                  | {activeCategoryDetails.lastUploadedBy}
                                </span>
                              </span>
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <DocumentCards
                  documents={
                    recordLists[activeCategoryDetails?.datacategory] || []
                  }
                  onCardAction={handleCardAction}
                  sortBySender={sortBySender}
                />
              </Col>
              <Col md={3} className='filter_rodrfs p-0'>
                <div className='sticky-sidebar'>
                  <DocumentCategoryList
                    categories={countResult}
                    selected={activeCategoryDetails?.datacategory || null}
                    onSelect={handleCategorySelect}
                    sortBySender={sortBySender}
                    caseInfoId={caseInfoId}
                  />
                </div>
              </Col>
            </Row>
          </>
        )}
        {isEditorFile && (
          <Col className='d-flex justify-content-start'>
            <Button
              variant='outline'
              className='d-flex align-items-center btn-text-border me-1'
              onClick={handleCloseEditor}
            >
              <span className='material-icons mr-2 '>arrow_back</span>
              Back
            </Button>
          </Col>
        )}
        {(!isViewerOpen && popUpListResult.length > 0) ? (
          <Modal
            show={showModalNew}
            onHide={handleCloseModalNew}
            size='xl'
            aria-labelledby='contained-modal-title-vcenter'
            centered
            className='recordList'
          >
            {showMessagePopUp && (
              <div className='alert alert-info text-center'>
                Download is in progress...
              </div>
            )}
            <Modal.Header closeButton className='d-flex'>
              <Modal.Title className='fw-bold text-left modelheading offcanvas-title d-flex align-items-center'>
                View Attachments{' '}
                <span className='text-dark fw-normal mx-1'>
                  {selectedFileName && selectedClientName ? (
                    <>
                      - {selectedFileName} -{' '}
                      <span style={{ fontWeight: 'bold' }}>
                        {formatClientName(selectedClientName)}
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </span>
                {totalPageCount != null && (
                  <>
                    <span className='ms-3 material-icons theme-color'>
                      auto_stories
                    </span>
                    <span className='ms-1 theme-color'>Pages -</span>{' '}
                    <span className='text-muted'>{totalPageCount}</span>
                  </>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DataTableForList
                headers={FILE_HEADERS}
                rows={popUpListResult}
                children_headers={VERSION_HEADER}
                onDownloadAction={handleDownloadAction}
                onViewPdf={viewPDF}
                documentType={selectedFileName}
              />
            </Modal.Body>
            <Modal.Footer className='border-top d-flex justify-content-end'>
              <Button
                variant='outline-info'
                onClick={handleCloseModalNew}
                className='d-flex align-items-center btn btn-outline-info'
              >
                <span className='material-icons mr-2'>close</span> Close
              </Button>
              <Button
                variant='primary'
                className='btn btn-primary d-flex align-items-center mx-2 btn btn-primary'
                onClick={handlePopUpDetailsFileDownloadAction}
              >
                <span className='material-icons mx-1'>download</span> Download
                All
              </Button>
            </Modal.Footer>
          </Modal>
        ) : null}

        <Modal
          show={showModalForROR}
          onHide={handleCloseModalROR}
          size='xl'
          aria-labelledby='contained-modal-title-vcenter'
          centered
          className='recordList'
        >
          <Modal.Header closeButton className='d-flex'>
            <Modal.Title className='fw-bold text-left modelheading offcanvas-title d-flex align-items-center'>
              Review of Records
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              {reviewRecordSummaryResult?.length ? (
                renderAccordionROR()
              ) : (
                <Row>
                  <span className="no_rec_data">No Record Found</span>
                </Row>
              )}
            </>
          </Modal.Body>
        </Modal>
      </Container>
      <PdfViewerDrawer
        isOpen={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        fileUrl={selectedPdfUrl}
      />
    </>
  );
};

export default RecordListNew;
